import { withChartLayout } from 'components/common';
import BradenScale from 'components/features/chart/special-charts/braden-scale/BradenScale';

const BradenScalePage = withChartLayout('Braden Scale')(BradenScale);
export default BradenScalePage;
